import { render, staticRenderFns } from "./OrgModerationView.vue?vue&type=template&id=07482bbc"
import script from "./OrgModerationView.vue?vue&type=script&lang=js"
export * from "./OrgModerationView.vue?vue&type=script&lang=js"
import style0 from "./OrgModerationView.vue?vue&type=style&index=0&id=07482bbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports